import { render, staticRenderFns } from "./statoOrdini.html?vue&type=template&id=335f0009&"
import script from "./StatoOrdini.vue?vue&type=script&lang=js&"
export * from "./StatoOrdini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports